<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue'

import { ButtonGroup } from '@collector/shared-ui'

import { injectAsideConfig } from '../../../provide-inject'
import History from './History/History.vue'

const LazyIncidentsTimeline = defineAsyncComponent(
  () => import('./IncidentsTimeline.vue'),
)

const LazyStatistics = defineAsyncComponent(() => import('./Statistics.vue'))

// state
const selectedOptionIndex = ref(0)

const config = injectAsideConfig()

const options = [
  { value: 'History', disabled: config?.disabledOptions.has('History') },
  {
    value: 'Incidents timeline',
    disabled: config?.disabledOptions.has('Incidents timeline'),
  },
  { value: 'Statistics', disabled: config?.disabledOptions.has('Statistics') },
]
</script>

<template>
  <div class="flex min-h-0 flex-col space-y-1">
    <ButtonGroup
      v-model="selectedOptionIndex"
      :options
      buttonClass="px-1!"
      fontSize="text-xs"
      variant="flat"
      width="full"
      withBorder
      roundedEdges
    />
    <div class="min-h-0 flex-1 overflow-hidden">
      <KeepAlive v-if="!options[0].disabled">
        <History
          v-if="selectedOptionIndex === 0"
          class="h-full overflow-y-auto"
        />
      </KeepAlive>

      <KeepAlive v-if="!options[1].disabled">
        <LazyIncidentsTimeline
          v-if="selectedOptionIndex === 1"
          class="h-full overflow-y-auto"
        />
      </KeepAlive>

      <KeepAlive v-if="!options[2].disabled">
        <LazyStatistics
          v-if="selectedOptionIndex === 2"
          class="h-full overflow-y-auto"
        />
      </KeepAlive>
    </div>
  </div>
</template>
